export const DEFAULT_ITEM_WITH_OPERATOR_VALUE = {
  value: undefined,
  operator: 'equal',
};
